import React, { useRef } from 'react'
import { TextField, InputAdornment, Box, Divider } from '@mui/material'
import InputMask from 'react-input-mask'
import { styled } from '@mui/system'

const StyledTextField = styled(({ hasIcon, ...other }) => <TextField {...other} />)(({ hasIcon }) => ({
  '& .MuiOutlinedInput-root': {
    '& .MuiInputBase-input': {
      borderRadius: hasIcon ? '0 8px 8px 0' : 'inherit'
    }
  }
}))

const MaskedTextInput = ({ icon, disabled = false, mask, ...props }) => {
  const inputRef = useRef(null)

  return mask ? (
    <InputMask maskChar="" mask={mask} {...props} disabled={disabled} ref={inputRef}>
      {inputProps => (
        <StyledTextField
          {...inputProps}
          disabled={disabled}
          hasIcon={Boolean(icon)}
          InputProps={{
            startAdornment: icon && (
              <InputAdornment position="start" sx={{ margin: 0, padding: 0 }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  {icon}
                  <Divider orientation="vertical" sx={{ height: 40, marginLeft: '12px' }} />
                </Box>
              </InputAdornment>
            )
          }}
        />
      )}
    </InputMask>
  ) : (
    <StyledTextField
      {...props}
      disabled={disabled}
      hasIcon={Boolean(icon)}
      InputProps={{
        startAdornment: icon && (
          <InputAdornment position="start" sx={{ margin: 0, padding: 0 }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              {icon}
              <Divider orientation="vertical" sx={{ height: 40, marginLeft: '12px' }} />
            </Box>
          </InputAdornment>
        )
      }}
    />
  )
}

export default MaskedTextInput
